import {useService} from '@cindedi/react-application';
import {A} from '@cindedi/ui/components/A';
import {Card} from '@cindedi/ui/components/Card';
import {H2} from '@cindedi/ui/components/Heading/H2';
import {Slot} from '@cindedi/ui/components/Slot';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {withErrorHandling} from '@cindedi/request-utilities/withErrorHandling';
import {useLoaderData} from '@remix-run/react';
import {formatSize} from '~/domains/file-system/utilities/formatSize';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface SobreOCindediLoaderData {
  content: string;
  cover: FileSystem.PublicCoverDto | null;
  files: FileSystem.PublicFileDto[];
}

export const meta: MetaFunction = function SobreOCindediMeta({matches}) {
  return seoMeta('sobre', {title: 'Sobre o CINDEDI - Cindedi', description: 'CINDEDI: referência em pesquisa sobre desenvolvimento humano e educação infantil. Conheça nossas pesquisas e contribua para a formação profissional!'}, matches);
};

export const loader: LoaderFunction = withErrorHandling(async function SobreOCindediLoader({context: {use}}) {
  const File = use('File');
  const Cover = use('Cover');
  const Metadata = use('Metadata');

  const aboutUs = await Metadata.findOrFail({where: {key: 'about-us'}});
  const files = await File.allFor(aboutUs);
  const cover = await Cover.findFor(aboutUs);

  return json({content: aboutUs.value, files, cover});
});

export default function SobreOCindediView() {
  const {content, files, cover} = useLoaderData<SobreOCindediLoaderData>();
  useService('organization/titlebar').setTitle('Sobre o CINDEDI');

  return (
    <PublicLayout cover={cover?.url}>
      <div className="flex gap-4 max-w-full flex-col lg:flex-row">
        <div className="flex flex-col flex-1 gap-2 pt-4 max-w-full">
          <div dangerouslySetInnerHTML={{__html: content}} />
        </div>
        {files.length > 0 && (
          <div className="flex flex-col w-full lg:w-72 gap-4">
            <Card aria-label={`Arquivos anexados`} className="p-4">
              <Slot name="title">
                <H2 className="pl-4 pt-4">Anexos</H2>
              </Slot>
              <ul>
                {files.map((file) => (
                  <li key={file.publicId} className="mb-4 break-words">
                    <A target="_blank" href={file.url}>
                      <div className="flex flex-col">
                        <span className="text-primary-12">{file.name}</span>
                        <span className="text-sm text-shade-11 flex gap-2">
                          <span>{formatSize(file.size)}</span>•<span>{file.extension}</span>
                        </span>
                      </div>
                    </A>
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
